import type { ValidationErrorItem } from '@frontend/api';

export const formatValidationErrorsForCopy = (
  errors: ValidationErrorItem[],
  ruleName?: string,
): string => {
  const header = ruleName ? `Errors for ${ruleName}` : 'Validation Errors';
  const lines = errors.map(
    (e) =>
      `• data path: ${e.path}\n• message: ${e.message}\n${
        e.offendingValue
          ? `• offending value: ${JSON.stringify(e.offendingValue)}\n`
          : ''
      }• code: ${e.code}\n• meta: ${JSON.stringify(e.meta)}`,
  );
  return `${header}\n\n${lines.join('\n')}`;
};

export const groupValidationErrorsByRule = (
  input: Array<{ ruleName?: string; errors: ValidationErrorItem[] }>,
): Record<string, ValidationErrorItem[]> => {
  const out: Record<string, ValidationErrorItem[]> = {};
  input.forEach(({ ruleName, errors }) => {
    const key =
      ruleName && ruleName.trim().length > 0 ? ruleName : 'Unnamed Rule';
    if (!out[key]) out[key] = [];
    errors.forEach((e) => out[key].push(e));
  });
  return out;
};
